import { Routes } from "@angular/router";

export const myTicketsRoutes: Routes = [
  {
    path: "",
    title: (route, state) => {
      return state.url.includes("admin") ? "TICKETS.RESERVATIONS" : "TICKETS.MY_RESERVATIONS";
    },
    loadComponent: () => import("./pages/my-tickets/my-tickets.component").then((c) => c.MyTicketsComponent),
  },
  {
    path: ":reservationNumber",
    /**
     * Asynchronously loads the TicketComponent from the shared components.
     */
    loadComponent: () => import("src/app/shared/components/ticket/ticket.component").then((c) => c.TicketComponent),
  },
];
